module.exports = __webpack_public_path__ + "static/media/pdfIcon.a13e9833.svg";